import React from 'react'

import { Box } from 'ui/acro'

import { breakpoints } from 'ui/acro'

import Section from '../common/components/Section/Section'
import Carousel from '../common/components/Carousel/Carousel'
import { FadeBox, ClassCard, SeriesCard } from '../common/components'
import { useFetchAPI } from 'hooks'

const RecommendationWidget = ({
  carousalType,
  data: config,
  location = '',
  ...rest
}) => {
  const data = config.fetchDataFrom
    ? useFetchAPI(config.fetchDataFrom?.replace('/api/v2', ''))[0]?.data
    : config?.carousalItems

  if (!data || data.length <= 0) {
    return <></>
  }
  const [slidesOffsetBefore, slidesOffsetAfter] = [0, 0]

  return (
    <Box>
      <Box display='flex' gap='2em' flexDirection='column'>
        <FadeBox
          id={config?.carousalName}
          inTrigger={data && true}
          appear={true}
        >
          <Section
            title={config?.carouselTag}
            headerText={config?.carousalName}
            linkId={'NewClassesSeeAll'}
            linkHref={config?.buttonLinkUrl}
            cta={config?.buttonLinkName}
          >
            <Carousel
              card={carousalType == 'class' ? ClassCard : SeriesCard}
              eventName={rest?.eventName}
              location={location}
              data={data}
              mx={['16px', '16px', '16px', '0px']}
              breakpoints={{
                0: {
                  slidesOffsetBefore,
                  slidesOffsetAfter
                },
                320: {
                  slidesPerView: location == 'homepage' ? 1.5 : 1.45,
                  slidesOffsetBefore,
                  slidesOffsetAfter
                },
                525: {
                  slidesPerView: 2,
                  slidesOffsetBefore,
                  slidesOffsetAfter
                },
                [breakpoints[0]]: {
                  slidesPerView: 2.5,
                  slidesOffsetBefore,
                  slidesOffsetAfter
                },
                790: {
                  slidesPerView: 3,
                  slidesOffsetBefore,
                  slidesOffsetAfter
                },
                900: {
                  slidesPerView: 3.5,
                  slidesOffsetBefore,
                  slidesOffsetAfter
                },
                [breakpoints[1]]: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                  slidesOffsetBefore,
                  slidesOffsetAfter
                },
                [breakpoints[2]]: {
                  slidesPerView: 4,
                  slidesOffsetBefore: 0,
                  spaceBetween: 20,
                  slidesOffsetAfter: 0
                }
              }}
            />
          </Section>
        </FadeBox>
      </Box>
    </Box>
  )
}

export default RecommendationWidget
